// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5925058","453":"234b4682","667":"4ac51879"}[chunkId] + ".chunk.js";
};